import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../../common/models';
import { UliItemTruckAssign, UliItemTruckInitialState, UliItemTruckListLoad } from './uli-item-truck.actions';
import { Observable } from 'rxjs';
import { UliItemTruckStateModel, UliItemTruckState } from './uli-item-truck.state';
import { UliItemActionParams, UliItemTruckListSearchCriteria } from '../../models';
import { filter, take } from 'rxjs/operators';
import { UliItemFacade } from '../uli-item.facade';

@Injectable({ providedIn: 'root' })
export class UliItemTruckFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<UliItemTruckStateModel> = this.store.select(UliItemTruckState.getState);
  loaded$: Observable<boolean> = this.store.select(UliItemTruckState.getLoaded);

  constructor(private store: Store, private uliItemFacade: UliItemFacade) {}

  loadAll(searchCriteria?: UliItemTruckListSearchCriteria): void {
    this.uliItemFacade.uliIdentifiers$.pipe(filter(Boolean), take(1)).subscribe((params: UliItemActionParams) => {
      this.store.dispatch(new UliItemTruckListLoad({ params, searchCriteria }));
    });
  }

  assignTruck(truckId: number): void {
    this.uliItemFacade.uliIdentifiers$
      .pipe(filter(Boolean), take(1))
      .subscribe((params: UliItemActionParams) => this.store.dispatch(new UliItemTruckAssign({ params, truckId })));
  }

  setInitialState(): void {
    this.store.dispatch(new UliItemTruckInitialState());
  }
}
